import { FontSizes } from "../assets/fonts/fontSizes";
import { Colors } from "../utils/colors";
import { Fonts } from "../utils/fonts";

type Props = {
  message: string;
};

export default function CenterMessage({ message }: Props) {
  return (
    <div style={styles.container}>
      <p style={styles.text}>{message}</p>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    minHeight: "60vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  text: {
    fontSize: FontSizes.lg,
    fontWeight: Fonts.Medium,
    color: Colors.White,
    fontFamily: "Inter",
  },
};
